import { useEffect, useState } from 'react';
import { useListContext } from 'react-admin';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField as MuiTextField, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { toast } from 'react-toastify';
import { reportHistoryDateRanges, HISTORICAL_REPORTS_STRINGS } from '../constants';
import { getReportDateRange } from '../utils/reports/historicalReportsUtils';

const HistoricalReportsFilter = () => {
  const { setFilters } = useListContext();

  const [dateRange, setDateRange] = useState('30');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    const { start_date, end_date } = getReportDateRange(30);
    setStartDate(start_date);
    setEndDate(end_date);
    setFilters({
      start_date: start_date,
      end_date: end_date,
    });
  }, []);

  const handleDateRangeChange = (value: string) => {
    if (value !== 'custom') {
      const { start_date, end_date } = getReportDateRange(Number(value));
      setDateRange(value);
      setStartDate(start_date);
      setEndDate(end_date);
    } else {
      setDateRange('custom');
      setStartDate('');
      setEndDate('');
    }
  };

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newStartDate = e.target.value;
    setStartDate(newStartDate);
    if (endDate && newStartDate >= endDate) {
      toast.error(HISTORICAL_REPORTS_STRINGS.ERRORS.START_BEFORE_END);
    }
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEndDate = e.target.value;

    if (startDate && startDate >= newEndDate) {
      toast.error(HISTORICAL_REPORTS_STRINGS.ERRORS.START_BEFORE_END);
      setEndDate('');
    } else {
      setEndDate(newEndDate);
    }
  };

  const applyFilters = () => {
    setFilters({
      start_date: startDate,
      end_date: endDate,
    });
  };

  const isApplyDisabled = !dateRange || (dateRange === 'custom' && (!startDate || !endDate));

  return (
    <Box display="flex" alignItems="flex-end" gap={3} p={2} flexWrap="nowrap">
      <FormControl size="small">
        <InputLabel>{HISTORICAL_REPORTS_STRINGS.FILTERS.DATE_RANGE}</InputLabel>
        <Select
          label="Date Range"
          value={dateRange}
          onChange={(e) => handleDateRangeChange(e.target.value as string)}
          style={{ width: 160 }}
        >
          {reportHistoryDateRanges.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <MuiTextField
        label="Start Date"
        type="date"
        value={startDate}
        onChange={handleStartDateChange}
        disabled={dateRange !== 'custom'}
        InputLabelProps={{ shrink: true }}
        size="small"
      />

      <MuiTextField
        label="End Date"
        type="date"
        value={endDate}
        onChange={handleEndDateChange}
        disabled={dateRange !== 'custom'}
        InputLabelProps={{ shrink: true }}
        size="small"
      />

      <Button
        variant="contained"
        onClick={applyFilters}
        disabled={isApplyDisabled}
        startIcon={<SearchIcon />}
        sx={{
          minWidth: 100,
          height: 40,
          px: 2,
          borderRadius: 2,
          fontSize: '0.85rem',
          fontWeight: 500,
          textTransform: 'none',
        }}
      >
        {HISTORICAL_REPORTS_STRINGS.FILTERS.APPLY}
      </Button>
    </Box>
  );
};

export default HistoricalReportsFilter;
